module.exports = __webpack_public_path__ + "static/dania-40783bfaeec462fc490d666bfab4a8a1.png";